import { validateInstitutionReportTemplatePresence } from './validateInstitutionReportTemplatePresence'
import { validateInstitutionReportTemplateUniqueness } from './validateInstitutionReportTemplateUniqueness'
import { validateInstitutionUniqueness } from './validateInstitutionUniqueness'

const validate = (datasets, multipleInstitutionsAllowed, localize, locale) => {
  const validationErrors = []

  // 1) Pokud je v jakemkoli datasetu dvojice (InstitutionId, ReportTemplateVersionId), pak musi byt i v ostatnich Datasetech
  const validationResult1 = validateInstitutionReportTemplatePresence(datasets, localize('Reporting.MissingReportSubmissionValidationText'), locale)
  if (validationResult1 !== null) { validationErrors.push(validationResult1) }

  // 2) V ramci jednoho datasetu musi byt dvojice (InstitutionId, ReportTemplateVersionId) pouze jednou
  const validationResult2 = validateInstitutionReportTemplateUniqueness(datasets, localize('Reporting.MultipleReportSubmissionValidationText'), locale)
  if (validationResult2 !== null) { validationErrors.push(validationResult2) }

  // 3) Pokud neni OutputReportGroupDefinition  MultipleInstitutions == true, nesmi byt pres vsechny datasety vybrane ReportSubmissionGroups od vice nez jedne InstitutionId
  const validationResult3 = validateInstitutionUniqueness(datasets, multipleInstitutionsAllowed, localize('Reporting.MultipleInstitutionsText'))
  if (validationResult3 !== null) { validationErrors.push(validationResult3) }

  return validationErrors
}

export {
  validate
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/outputReportGenerator/validation/index.js